import { ControlProps } from 'nuka-carousel';
import beTwMerge from '@/utils/beTwMerge';

interface RightNavArrowProps extends ControlProps {
  btnClass?: string;
  containerClass?: string;
  containerStyle?: any;
  slidesToShow: number;
  item: any;
}

export default function RightNavArrow({
  btnClass,
  containerClass,
  containerStyle,
  nextSlide,
  currentSlide,
  slideCount,
  slidesToShow,
  item,
}: RightNavArrowProps): JSX.Element {
  return (
    <div
      className={beTwMerge(
        'tw-absolute tw-hidden lg:tw-flex tw-flex-col tw-justify-center tw-right-6 tw-top-0 tw-pointer-events-none',
        item.description ? 'tw-h-[calc(100%-74px)]' : 'tw-h-[calc(100%-46px)]',
        containerClass
      )}
      style={containerStyle}
    >
      <button
        type="button"
        onClick={nextSlide}
        className={beTwMerge(
          'tw-w-11 tw-h-11 tw-border-none tw-rounded-full tw-bg-white tw-drop-shadow-xl tw-pointer-events-auto',
          (currentSlide ?? 0) >= (slideCount ?? 0) - slidesToShow ? 'tw-hidden' : '',
          btnClass
        )}
        aria-label="Next"
      >
        <i className="iconfont iconfont-right" />
      </button>
    </div>
  );
}
